<nz-layout class="app-layout">
  <nz-sider class="menu-sidebar" nzCollapsible nzWidth="200px" nzBreakpoint="md" [nzCollapsedWidth]="80"
    [(nzCollapsed)]="isCollapsed" [nzTrigger]="null">
    <div class="sidebar-logo">
      <a href="#" target="_blank">
        <img src="../../../assets/images/thinkaerial.png" alt="THink AeriAL" class="logo">
        <h1>TASS Panel</h1>
      </a>
    </div>
    <ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <li nz-submenu nzOpen nzTitle="Dashboard" nzIcon="dashboard">
        <ul>
          <li nz-menu-item nzMatchRouter>
            <a routerLink="/user/dashboard">Streams</a>
          </li>
          <li nz-menu-item nzMatchRouter>
            <a routerLink="/user/pilots">Pilots</a>
          </li>
        </ul>
      </li>
      <!-- <li nz-submenu nzOpen nzTitle="Form" nzIcon="form">
          <ul>
            <li nz-menu-item nzMatchRouter>
              <a>Basic Form</a>
            </li>
          </ul>
        </li> -->
    </ul>
  </nz-sider>
  <nz-layout>
    <nz-header>
      <div class="app-header">
        <span class="header-trigger" (click)="isCollapsed = !isCollapsed">
          <i class="trigger" nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></i>
        </span>
        <img src="../../../assets/images/thinkaerial.png" class="img-fluid sideLogo" alt="">
        <nz-page-header-extra>
          <img src="../../../assets/images/" class="img-fluid sideLogo" alt="">
          <button nz-button (click)="logout()">Logout</button>
        </nz-page-header-extra>
      </div>
    </nz-header>
    <nz-content>
      <div class="inner-content">
        <router-outlet></router-outlet>
      </div>
    </nz-content>
  </nz-layout>
</nz-layout>
